import { CheckedSuppliersAdmin } from "../../components";

const CheckedSuppliers = () => {
  return <CheckedSuppliersAdmin />;
};

export default CheckedSuppliers;
